import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';


setupFacebookPixel();
if (environment.production || environment.staging) {
enableProdMode();
}

function setupFacebookPixel() {
const script = document.createElement('script');
const inlineScript = document.createTextNode(`
!function(f,b,e,v,n,t,s){if(f.fbq)return;
n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${environment.pixelId}');fbq('track', 'PageView');`);
script.appendChild(inlineScript);
document.head.appendChild(script);
}

platformBrowserDynamic().bootstrapModule(AppModule);
